import { useBahasa, type Bahasa } from '../i18n';

const LABEL: Record<Bahasa, string> = {
  en: 'English',
  id: 'Bahasa Indonesia',
};

/** Kode dua huruf, ditulis besar — cukup lebar untuk dibaca, cukup sempit untuk rail 64px. */
const KODE: Record<Bahasa, string> = { en: 'EN', id: 'ID' };

/**
 * Pilih bahasa (§H9). Duduk di kaki sidebar, tepat di atas toggle tema —
 * diminta lapangan bersamaan dengan pemindahan keduanya ke sana: *"Bahasanya
 * yang konsisten... Kalo perlu malah bikin bisa ganti bahasa."*
 *
 * Bentuknya sama persis dengan `ThemeToggle`, termasuk varian barisnya, supaya
 * dua kendali yang bersebelahan dan bersifat sama tidak terlihat seperti dua
 * jenis barang. Dua bahasa saja, jadi ia saklar, bukan daftar pilihan: menu
 * berisi dua baris adalah dua ketukan untuk pekerjaan satu ketukan.
 *
 * Yang ditampilkan adalah bahasa yang **sedang aktif**, bukan yang akan dituju —
 * pertanyaan yang dibawa orang ke tombol ini adalah "sekarang bahasa apa".
 */
export function LanguageToggle({ bentuk = 'ikon' }: { bentuk?: 'ikon' | 'baris' }) {
  const { bahasa, setBahasa, t } = useBahasa();
  const lain: Bahasa = bahasa === 'en' ? 'id' : 'en';

  const ganti = () => setBahasa(lain);
  const nama = t('Language. Click to switch.');

  if (bentuk === 'baris') {
    return (
      <button
        type="button"
        onClick={ganti}
        aria-label={nama}
        className="flex min-h-tap w-full items-center gap-3 rounded-md px-3 text-sm text-content transition-colors hover:bg-subtle"
      >
        {/* Kotak selebar ikon navigasi (20px) supaya labelnya sebaris dengan
            label item menu dan dengan toggle tema di bawahnya. */}
        <span
          aria-hidden="true"
          className="flex w-5 shrink-0 justify-center text-[11px] font-semibold tracking-wide"
        >
          {KODE[bahasa]}
        </span>
        <span className="truncate" aria-hidden="true">
          {LABEL[bahasa]}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={ganti}
      aria-label={nama}
      title={LABEL[bahasa]}
      className="grid min-h-tap min-w-tap place-items-center rounded-md border border-line text-[11px] font-semibold tracking-wide text-content transition-colors hover:bg-subtle"
    >
      <span aria-hidden="true">{KODE[bahasa]}</span>
    </button>
  );
}
